.container {
  padding: var(--mirai-ui-space-XS);
  max-height: calc(100vh - var(--mirai-ui-space-L) * 4);
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  overflow-y: auto;
}
